import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';

const COOKIE_NAME = 'SESSION_THEME';

const jwt_helper = new JwtHelperService();

function setCookie(cname, cvalue, exdays) {
	let d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	let expires = "expires="+d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  
function getCookie(cname) {
	let name = cname + "=";
	let ca = document.cookie.split(';');
	for(let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
		c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
		return c.substring(name.length, c.length);
		}
	}
	return "";
}
  
let SESSION = getCookie(COOKIE_NAME);
if (!SESSION) {
	SESSION = uuidv4();
}
setCookie(COOKIE_NAME, SESSION, 90);

function uuidv4() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            setHeaders: {
                'Cache-Control': 'no-cache',
                'SESSION': SESSION
            }
        });

        return next.handle(request).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    const token = event.headers.get('authorization');
                    if (token != null)  {
                        try {
                            let decoded_token = jwt_helper.decodeToken(token);
                            if (decoded_token.CodCliente == '0' && decoded_token.IdAnagRtc == '0')
                                localStorage.setItem('public_token', token);
                            else
                                localStorage.setItem('token', token);
                        } catch (err) {}
                    }
                }
            })
        )
    }
}